import { render } from "./ModalSelectPickupDelivery.vue?vue&type=template&id=5930911c&scoped=true"
import script from "./ModalSelectPickupDelivery.vue?vue&type=script&lang=js"
export * from "./ModalSelectPickupDelivery.vue?vue&type=script&lang=js"

import "./ModalSelectPickupDelivery.vue?vue&type=style&index=0&id=5930911c&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5930911c"]])

export default __exports__